import { Component, ChangeDetectionStrategy, ViewChild, signal, output } from '@angular/core';

import { TranslocoDirective } from '@ngneat/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { CouponValidationErrorCode } from '@pedix-workspace/utils';

@Component({
  selector: 'pxw-coupon-validation-error-dialog',
  templateUrl: './coupon-validation-error-dialog.component.html',
  styleUrls: ['./coupon-validation-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class CouponValidationErrorDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  couponValidationError = signal<CouponValidationErrorCode | null>(null);

  removeCoupon = output<void>();

  open(couponValidationError: CouponValidationErrorCode) {
    this.couponValidationError.set(couponValidationError);

    return this.modalDialog.open(async () => {
      this.removeCoupon.emit();
    });
  }
}
